export const en: Record<string, string> = {
  // Navbar
  'navbar.products': 'Products',
  'navbar.useCases': 'Use Cases',
  'navbar.pricing': 'Pricing',
  'navbar.about': 'About',
  'navbar.contact': 'Contact',
  'navbar.bookDemo': 'Book a Demo',
  'navbar.tripppMap': 'Trippp Map',
  'navbar.tripppSpark': 'Trippp Spark',
  'navbar.tripppTripOps': 'Trippp Ops',
  'navbar.dmosAndTourismBoards': 'DMOs & Tourism Boards',
  'navbar.dmcsAndTravelAgencies': 'DMCs & Travel Agencies',
  'navbar.hotelsAndResorts': 'Hotels & Resorts',
  'navbar.realEstateAndLifestyle': 'Real Estate & Lifestyle',

  // Hero
  'hero.title': 'Power the complete journey',
  'hero.subtitle':
    'The modular tourism technology platform that powers everything from first desire to last day on the ground.',
  'hero.bookDemo': 'Book a Demo',
  'hero.exploreProducts': 'Explore Products',

  // Social Proof
  'socialProof.trusted':
    'Trusted by destinations and agencies across the world',

  // Product Suite
  'productSuite.title': 'One platform. Three products.',
  'productSuite.subtitle':
    'Modular architecture designed to scale with your tourism business.',
  'productSuite.learnMore': 'Learn more',
  'productSuite.mapName': 'Trippp Map',
  'productSuite.mapDesc':
    'A white-label interactive destination map. Points of interest, itineraries, hiking trails, and multilingual content — all managed through a dedicated CMS.',
  'productSuite.sparkName': 'Trippp Spark',
  'productSuite.sparkDesc':
    'A cinematic, mood-based discovery experience. Travelers explore a destination emotionally before they ever book a flight.',
  'productSuite.opsName': 'Trippp Ops',
  'productSuite.opsDesc':
    'A traveler app and operations platform in one. White-labeled per trip, it gives travelers their full program while giving agencies total visibility on extras and commissions.',

  // Persona Tabs
  'personaTabs.sectionTitle': 'Built for your industry.',
  'personaTabs.tab0Label': 'DMOs & Tourism Boards',
  'personaTabs.tab1Label': 'DMCs & Travel Agencies',
  'personaTabs.tab2Label': 'Hotels & Resorts',
  'personaTabs.tab3Label': 'Real Estate & Lifestyle Developers',
  'personaTabs.content0Title':
    'Put your destination on the digital map — literally.',
  'personaTabs.content0Desc':
    'Give visitors an interactive, multilingual window into everything your region offers. From hidden trails to curated itineraries, Trippp Map and Spark turn any destination into a world-class digital experience — fully branded as yours.',
  'personaTabs.content0Feature0': 'Interactive destination map with CMS',
  'personaTabs.content0Feature1': 'Cinematic discovery experience',
  'personaTabs.content0Feature2': 'Multilingual — AI-powered, any language',
  'personaTabs.content1Title':
    'Run tighter operations. Win more international mandates.',
  'personaTabs.content1Desc':
    'Trippp Ops gives your agency a white-labeled traveler app for every operation — extras marketplace, documents, program, emergency contacts. International partners choose you because you offer transparency they can trust.',
  'personaTabs.content1Feature0': 'White-labeled traveler app per trip',
  'personaTabs.content1Feature1': 'Extras marketplace & commissions',
  'personaTabs.content1Feature2': 'Real-time operational visibility',
  'personaTabs.content2Title':
    'Show guests what surrounds them before they arrive.',
  'personaTabs.content2Desc':
    'Embed Spark directly into your website. Let future guests explore your property and the destination around it through a cinematic experience that no static gallery can match.',
  'personaTabs.content2Feature0': 'Embeddable cinematic experience',
  'personaTabs.content2Feature1': 'Destination-aware property showcase',
  'personaTabs.content2Feature2': 'Immersive pre-arrival engagement',
  'personaTabs.content3Title': 'Sell the lifestyle, not just the property.',
  'personaTabs.content3Desc':
    "Map and Spark give your buyers an immersive view of the destination they're investing in — trails, restaurants, culture, experiences. The environment becomes part of the pitch.",
  'personaTabs.content3Feature0': 'Immersive destination mapping',
  'personaTabs.content3Feature1': 'Lifestyle-driven buyer experience',
  'personaTabs.content3Feature2': 'Environment as selling point',

  // Use Cases
  'useCases.sectionTitle': 'See it in the real world.',
  'useCases.case0Label': 'Tourism Board',
  'useCases.case0Title': 'Visit Beni Mellal-Khénifra',
  'useCases.case0Desc':
    "A regional tourism board in Morocco deployed Trippp Map and Spark to digitise a previously underpromoted destination — giving visitors an interactive, multilingual window into the region's mountains, valleys, and culture.",
  'useCases.case1Label': 'Tourism Board',
  'useCases.case1Title': 'Visit Draa-Tafilalet',
  'useCases.case1Desc':
    "Morocco's gateway to the Sahara now has an interactive destination map covering its vast territory — cities, oases, kasbahs, and trekking routes, all fully multilingual.",
  'useCases.case2Label': 'DMC',
  'useCases.case2Title': 'Lumi Morocco',
  'useCases.case2Desc':
    "A Moroccan DMC deployed Trippp Ops to give their international clients' travelers a fully branded in-trip experience — program, extras, documents, and real-time communication, all under the Lumi name.",
  'useCases.explore': 'Explore',
  'useCases.comingSoon': 'Coming soon',

  // How It Works
  'howItWorks.title': 'How it works',
  'howItWorks.subtitle':
    'From first conversation to full deployment in weeks, not months.',
  'howItWorks.step0Title': 'Consult',
  'howItWorks.step0Desc': 'We analyze your unique operational needs and goals.',
  'howItWorks.step1Title': 'Configure',
  'howItWorks.step1Desc':
    'Select and customize the modules that fit your business.',
  'howItWorks.step2Title': 'Deploy',
  'howItWorks.step2Desc': 'Launch your branded platform and start scaling.',

  // Pricing Teaser
  'pricingTeaser.title': 'Transparent pricing. No surprises.',
  'pricingTeaser.desc':
    'Trippp is priced per product, per deployment. Annual licenses, one-time setup, and a per-operation model for Trippp Ops. No hidden fees, no enterprise black boxes.',
  'pricingTeaser.cta': 'See full pricing',

  // Final CTA
  'finalCTA.titlePart1': 'Tourism technology built for the people who ',
  'finalCTA.titleHighlight': 'build the destination',
  'finalCTA.desc':
    'Not adapted from generic SaaS. Built from the ground up for how tourism actually works.',
  'finalCTA.cta': 'Book a 30-minute walkthrough',

  // Footer
  'footer.tagline':
    'The modular tourism technology platform that powers the complete journey.',
  'footer.products': 'Products',
  'footer.company': 'Company',
  'footer.aboutUs': 'About Us',
  'footer.careers': 'Careers',
  'footer.blog': 'Blog',
  'footer.contact': 'Contact',
  'footer.language': 'Language',
  'footer.copyright': '© {year} Trippp Technologies. All rights reserved.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',

  // Pricing Page
  'pricing.heroTitle': 'Transparent pricing. ',
  'pricing.heroTitleHighlight': 'No surprises.',
  'pricing.heroDesc':
    'Every product has clear annual licensing. No hidden fees, no enterprise black boxes. Pick what you need, know what you pay.',
  'pricing.mapTitle': 'Trippp Map',
  'pricing.mapSubtitle': 'Annual license + one-time setup',
  'pricing.sparkTitle': 'Trippp Spark',
  'pricing.sparkSubtitle': 'Annual license + one-time setup',
  'pricing.opsTitle': 'Trippp Ops',
  'pricing.opsSubtitle': "Two options. Scale when you're ready.",
  'pricing.tier': 'Tier',
  'pricing.annualLicense': 'Annual License',
  'pricing.setup': 'Setup (one-time)',
  'pricing.city': 'City',
  'pricing.region': 'Region',
  'pricing.country': 'Country / Multi-region',
  'pricing.hotelProperty': 'Hotel / Property',
  'pricing.mapIncludes':
    'Includes hosting, CMS access, API, platform updates, and multilingual support.',
  'pricing.dmoTourismBoard': 'DMO / Tourism Board',
  'pricing.agency': 'Agency',
  'pricing.sparkIncludes':
    'Includes hosting, white-label configuration, and platform updates.',
  'pricing.platformLicense': 'Platform license',
  'pricing.perOperation': 'Per operation',
  'pricing.singleOperation': 'Single Operation',
  'pricing.noCommitment': 'No commitment',
  'pricing.oneTimeLabel': '(one-time)',
  'pricing.year': '/ year',
  'pricing.op': '/ op',
  'pricing.platformLicenseDesc':
    'Full admin access, CMS, branding toolkit, unlimited staff accounts.',
  'pricing.perOperationDesc':
    'Linear. No tiers. No volume commitments. Each operation can be white-labeled independently.',
  'pricing.singleOperationDesc':
    'One operation, one price. No annual license, no commitment. Ideal for a first deployment or a one-off trip.',
  'pricing.exampleNote':
    'Annual license: an agency running 10 operations/year pays €4,800 + €5,000 = €9,800. Or try a single operation for €3,000 with no commitment.',
  'pricing.bundleNote': 'Using more than one Trippp product? ',
  'pricing.bundleHighlight': 'Ask us about bundle pricing.',
  'pricing.faqTitle': 'Frequently Asked Questions',
  'pricing.faq0Q': "What's included in the annual license?",
  'pricing.faq0A':
    'Hosting, platform updates, CMS access, API access, white-label configuration, and multilingual support. Everything you need to run the product.',
  'pricing.faq1Q': 'How long does deployment take?',
  'pricing.faq1A':
    'Typically 2–4 weeks from kickoff to live, depending on content readiness and scope.',
  'pricing.faq2Q': 'Can I start with one product and add others later?',
  'pricing.faq2A':
    "Yes. Every product is independent. Add Map, Spark, or Trippp Ops whenever you're ready.",
  'pricing.faq3Q': 'Is there a commitment period?',
  'pricing.faq3A': 'Licenses are annual. No multi-year lock-in required.',
  'pricing.ctaTitle': 'Know the price. See the product. ',
  'pricing.ctaHighlight': 'Decide with clarity.',
  'pricing.ctaCta': 'Book a 30-minute walkthrough',

  // About Page
  'about.heroTitle': 'We build technology for the people who ',
  'about.heroTitleHighlight': 'build destinations.',
  'about.heroDesc':
    'Trippp was born from real deployments in real destinations. Not from a pitch deck — from the field.',
  'about.originTitle': 'Where Trippp comes from.',
  'about.originP1':
    'Trippp started as a set of tools built for tourism boards that needed real digital infrastructure — not another template website, not another PDF brochure.',
  'about.originP2':
    'Interactive maps, cinematic discovery experiences, and operational platforms were designed, deployed, and battle-tested across live destinations before Trippp became a product company.',
  'about.originP3':
    'Every feature exists because a client needed it in the real world.',
  'about.beliefsTitle': 'Three things we stand for.',
  'about.belief0Title': 'Built for tourism, not adapted to it.',
  'about.belief0Desc':
    'Generic SaaS tools force tourism professionals to bend their workflow. Trippp was designed from day one around how destinations, agencies, and hotels actually operate.',
  'about.belief1Title': 'Modular by design.',
  'about.belief1Desc':
    'No one needs everything on day one. Pick one product, add more when it makes sense. No forced bundles, no bloated packages.',
  'about.belief2Title': 'White-label by default.',
  'about.belief2Desc':
    'Your brand, your domain, your identity. Trippp disappears behind whatever name you choose to put forward.',
  'about.deployedTitle': 'Deployed. Live. Working.',
  'about.deployment0Title': 'Visit Beni Mellal-Khénifra',
  'about.deployment0Desc': 'Regional interactive map & cinematic discovery.',
  'about.deployment1Title': 'Visit Draa-Tafilalet',
  'about.deployment1Desc': 'Vast territory mapping, fully multilingual.',
  'about.deployment2Title': 'Lumi Morocco',
  'about.deployment2Desc':
    'White-labeled traveler app and operations dashboard.',
  'about.seeItLive': 'See it live',
  'about.ctaTitle': 'Want to see what Trippp can do for ',
  'about.ctaHighlight': 'your destination?',
  'about.ctaCta': 'Book a 30-minute walkthrough',

  // Contact Page
  'contact.heroTitle': "Let's ",
  'contact.heroTitleHighlight': 'talk.',
  'contact.heroDesc':
    'Have a question, a specific need, or just want to know more? Write to us directly.',
  'contact.nameLabel': 'Name',
  'contact.namePlaceholder': 'Jane Doe',
  'contact.emailLabel': 'Email',
  'contact.emailPlaceholder': 'jane@example.com',
  'contact.companyLabel': 'Company',
  'contact.companyPlaceholder': 'Company Name',
  'contact.roleLabel': 'Role',
  'contact.roleSelectRole': 'Select role...',
  'contact.roleDmo': 'DMO & Tourism Board',
  'contact.roleAgency': 'DMC & Travel Agency',
  'contact.roleHotel': 'Hotel & Resort',
  'contact.roleRealestate': 'Real Estate Developer',
  'contact.roleOther': 'Other',
  'contact.messageLabel': 'Message',
  'contact.messagePlaceholder': 'How can we help?',
  'contact.sendMessage': 'Send message',
  'contact.responseTime': 'We typically respond within 24 hours.',
  'contact.demoTitle': 'Prefer to see the product live?',
  'contact.demoDesc':
    'No slides. No pitch deck. We show you the real product running on real destinations.',
  'contact.demoCta': 'Book a 30-minute walkthrough →',
  'contact.faqTitle': 'Frequently Asked ',
  'contact.faqHighlight': 'Questions',
  'contact.faq0Q': 'What happens during the demo?',
  'contact.faq0A':
    'We walk you through the live product — Map, Spark, or Trippp Ops depending on your needs — running on real destination deployments. No mockups.',
  'contact.faq1Q': 'Do I need to prepare anything?',
  'contact.faq1A':
    'No. Just bring your questions. If you want us to focus on a specific product, mention it when you book.',
  'contact.faq2Q': 'Is this a sales call?',
  'contact.faq2A':
    "It's a product walkthrough. You'll see exactly what you'd be getting. Pricing is on our website — no surprises.",

  // Trippp Map Page
  'tripppMap.badge': 'Trippp Map',
  'tripppMap.heroTitle': 'Every point of interest. Every trail. Every story. ',
  'tripppMap.heroTitleHighlight': 'One map.',
  'tripppMap.heroDesc':
    'Trippp Map is a white-label, interactive destination map powered by a dedicated CMS. Deploy it for a city, a region, or an entire country — fully branded, multilingual, and ready in weeks.',
  'tripppMap.bookDemo': 'Book a Demo',
  'tripppMap.seeItLive': 'See it live',
  'tripppMap.featuresTitle': 'Everything a destination needs in one platform.',
  'tripppMap.feature0Title': 'Interactive Map',
  'tripppMap.feature0Desc':
    'A fully navigable map with custom styling, filterable points of interest, and smooth mobile experience.',
  'tripppMap.feature1Title': 'Curated Itineraries',
  'tripppMap.feature1Desc':
    'Pre-built trip routes that guide visitors through your destination day by day.',
  'tripppMap.feature2Title': 'Hiking & Trail Module',
  'tripppMap.feature2Desc':
    'GPS-powered trails with elevation, distance, difficulty, and downloadable routes.',
  'tripppMap.feature3Title': 'Multilingual Content',
  'tripppMap.feature3Desc':
    'Every piece of content translatable to any language your audience needs — powered by AI.',
  'tripppMap.feature4Title': 'Dedicated CMS',
  'tripppMap.feature4Desc':
    'A back-office built specifically for tourism — manage places, tags, tours, deals, articles, and media from one dashboard.',
  'tripppMap.feature5Title': 'Progressive Web App',
  'tripppMap.feature5Desc':
    'Installable on any phone. Works offline. Sends update notifications. No app store needed.',
  'tripppMap.targetsTitle': 'Built for destinations of any scale.',
  'tripppMap.target0Title': 'City',
  'tripppMap.target0Desc':
    'A single municipality or urban destination looking to digitise its visitor experience.',
  'tripppMap.target1Title': 'Region',
  'tripppMap.target1Desc':
    'A province, governorate, or multi-city territory with diverse attractions to organise and promote.',
  'tripppMap.target2Title': 'Country',
  'tripppMap.target2Desc':
    'A national tourism body deploying a unified digital map across multiple regions.',
  'tripppMap.target3Title': 'Hotel / Property',
  'tripppMap.target3Desc':
    'A resort or hotel showcasing the surroundings and local experiences available to guests.',
  'tripppMap.deploymentsTitle': 'See Trippp Map in the real world.',
  'tripppMap.deployment0Title': 'Visit Beni Mellal-Khénifra',
  'tripppMap.deployment0Desc':
    'A regional tourism board in Morocco covering mountains, waterfalls, valleys, and historic cities. Map deployed with full CMS, multilingual content, itineraries, hiking trails, and curated deals.',
  'tripppMap.deployment1Title': 'Visit Draa-Tafilalet',
  'tripppMap.deployment1Desc':
    "Morocco's gateway to the Sahara. Interactive map spanning a vast territory of oases, kasbahs, desert routes, and trekking trails — all fully multilingual.",
  'tripppMap.exploreTheMap': 'Explore the map',
  'tripppMap.techTitle': 'Under the hood.',
  'tripppMap.tech0':
    'REST API architecture — every data point accessible via documented endpoints',
  'tripppMap.tech1': 'Mapbox GL JS with custom cartographic styling',
  'tripppMap.tech2': 'AWS-hosted media with CDN delivery',
  'tripppMap.tech3': 'MongoDB-backed content with real-time CMS sync',
  'tripppMap.tech4': 'Swagger/OpenAPI documentation included',
  'tripppMap.tech5': 'White-label: your domain, your logo, your colours',
  'tripppMap.ctaTitle': 'Ready to put your destination ',
  'tripppMap.ctaHighlight': 'on the map?',
  'tripppMap.ctaCta': 'Book a 30-minute walkthrough',

  // Trippp Spark Page
  'tripppSpark.badge': 'Trippp Spark',
  'tripppSpark.heroTitle': 'Before they search. Before they book. ',
  'tripppSpark.heroTitleHighlight': 'They feel.',
  'tripppSpark.heroDesc':
    "Trippp Spark is a cinematic, mood-based discovery experience. Travelers don't filter by date or price — they swipe through visual stories until a destination speaks to them. White-label it as your own and embed it anywhere.",
  'tripppSpark.bookDemo': 'Book a Demo',
  'tripppSpark.experienceItLive': 'Experience it live',
  'tripppSpark.howItWorksTitle': 'Discovery through emotion, not logistics.',
  'tripppSpark.step0Title': 'Feel',
  'tripppSpark.step0Desc':
    'Visitors land on an immersive, full-screen visual experience. No menus. No search bars. Just imagery and mood.',
  'tripppSpark.step1Title': 'Explore',
  'tripppSpark.step1Desc':
    'They swipe, scroll, and tap into visual categories — adventure, serenity, culture, nightlife — discovering places through how they feel, not where they are.',
  'tripppSpark.step2Title': 'Connect',
  'tripppSpark.step2Desc':
    'Each experience links to detailed content — places, stories, practical info — bridging emotion with action.',
  'tripppSpark.targetsTitle': 'Spark lives wherever first impressions matter.',
  'tripppSpark.target0Title': 'DMO / Tourism Board',
  'tripppSpark.target0Desc':
    'Deploy Spark as the emotional front door to your destination. A full cinematic experience covering everything your region offers, fully branded.',
  'tripppSpark.target1Title': 'Hotel / Resort',
  'tripppSpark.target1Desc':
    'Embed Spark on your website. Let potential guests feel the property and its surroundings before they ever check availability.',
  'tripppSpark.target2Title': 'Agency',
  'tripppSpark.target2Desc':
    'Add Spark as an experience page on your client-facing sites. Differentiate your brand with a discovery layer no competitor has.',
  'tripppSpark.deploymentTitle': 'See Trippp Spark in the real world.',
  'tripppSpark.deployment0Title': 'Visit Beni Mellal-Khénifra — Inspiring Mode',
  'tripppSpark.deployment0Desc':
    'The regional tourism board deployed Spark alongside Map to create a dual experience: visitors can explore logically through Map or emotionally through Spark. Both platforms share the same API and CMS content.',
  'tripppSpark.experienceIt': 'Experience it',
  'tripppSpark.differentTitle': 'Not a gallery. Not a slider. A new format.',
  'tripppSpark.diff0':
    'Full-screen, cinematic-first. Designed to be felt, not scanned.',
  'tripppSpark.diff1':
    'Content powered by the same CMS and API as Trippp Map. One source of truth.',
  'tripppSpark.diff2':
    'White-label: your brand, your domain, your visual identity.',
  'tripppSpark.diff3':
    'Embeddable as a standalone page or integrated into any existing website.',
  'tripppSpark.ctaTitle': 'Give your audience a reason to dream ',
  'tripppSpark.ctaHighlight': 'before they plan.',
  'tripppSpark.ctaCta': 'Book a 30-minute walkthrough',

  // Trippp Ops Page
  'tripppOps.badge': 'Trippp Ops',
  'tripppOps.heroTitle':
    'One app for the traveler. One dashboard for the agency. ',
  'tripppOps.heroTitleHighlight': 'Total clarity for everyone.',
  'tripppOps.heroDesc':
    'Trippp Ops is a white-label traveler app and operations platform. For each operation, your travelers get their full program, extras marketplace, documents, and emergency contacts. Your team gets booking visibility, commission tracking, and broadcast messaging. Branded differently for every trip if you need it.',
  'tripppOps.bookDemo': 'Book a Demo',
  'tripppOps.seeHowItWorks': 'See how it works',
  'tripppOps.travelerTitle': 'What your travelers see.',
  'tripppOps.traveler0Title': 'Trip Program',
  'tripppOps.traveler0Desc':
    'Day-by-day itinerary accessible via a unique Trip Code. No app download required.',
  'tripppOps.traveler1Title': 'Extras Marketplace',
  'tripppOps.traveler1Desc':
    'Transfers, excursions, spa, restaurants — travelers browse and book optional services directly.',
  'tripppOps.traveler2Title': 'Documents Library',
  'tripppOps.traveler2Desc':
    'Vouchers, tickets, travel insurance, practical info — all in one place.',
  'tripppOps.traveler3Title': 'Emergency Contacts',
  'tripppOps.traveler3Desc':
    'Local emergency numbers, agency contacts, hotel info — always accessible.',
  'tripppOps.traveler4Title': 'Media Sharing',
  'tripppOps.traveler4Desc':
    'Photos and memories shared within the trip group.',
  'tripppOps.traveler5Title': 'Multilingual',
  'tripppOps.traveler5Desc':
    'Available in any language — AI-powered translation for every audience.',
  'tripppOps.agencyTitle': 'What your team controls.',
  'tripppOps.agency0Title': 'Trip Creation',
  'tripppOps.agency0Desc':
    'Spin up a new operation in minutes. Set the program, configure available extras, assign participants.',
  'tripppOps.agency1Title': 'White-Label per Operation',
  'tripppOps.agency1Desc':
    "Each trip can carry a different brand — your own, your partner's, or your client's. Logo, colours, domain.",
  'tripppOps.agency2Title': 'Booking & Commission Tracking',
  'tripppOps.agency2Desc':
    'See every extra booked, every service sold. Track commissions in real time across all operations.',
  'tripppOps.agency3Title': 'Participant Management',
  'tripppOps.agency3Desc':
    'Add travelers, manage access, monitor engagement per operation.',
  'tripppOps.agency4Title': 'Broadcast Messaging',
  'tripppOps.agency4Desc':
    'Send updates to all travelers in an operation via WhatsApp notifications.',
  'tripppOps.mandatesTitle': 'The tool that wins mandates.',
  'tripppOps.scenario0':
    "A Brazilian agency mandates Trippp Ops to their Moroccan DMC provider. Every operation in Morocco runs through the platform — white-labeled under the Brazilian agency's brand. The agency gets full visibility on extras sold and commissions earned, even from 10,000 km away.",
  'tripppOps.scenario1':
    'A Moroccan DMC pitches an international agency for a 200-person incentive trip. Their differentiator? A branded traveler app with a full service marketplace, document access, and real-time updates. The agency picks them over three competitors who offered spreadsheets and PDFs.',
  'tripppOps.deploymentTitle': 'See Trippp Ops in the real world.',
  'tripppOps.deployment0Title': 'Lumi Morocco',
  'tripppOps.deployment0Desc':
    'A Moroccan DMC deployed Trippp Ops to serve their international agency clients. Travelers access their full trip under the Lumi brand — program, extras, documents, emergency contacts — while the Lumi team manages bookings, tracks commissions, and communicates in real time.',
  'tripppOps.learnMore': 'Learn more',
  'tripppOps.pricingTitle': 'Simple pricing. Scales with your operations.',
  'tripppOps.platformLicense': 'Platform license',
  'tripppOps.perOperation': 'Per operation',
  'tripppOps.noPriceNote':
    'No hidden fees. No volume commitments. You pay when you operate.',
  'tripppOps.seeFullPricing': 'See full pricing',
  'tripppOps.ctaTitle': 'Stop managing trips on spreadsheets. ',
  'tripppOps.ctaHighlight': 'Start running operations.',
  'tripppOps.ctaCta': 'Book a 30-minute walkthrough',

  // Use Case DMO Page
  'useCaseDMO.badge': 'DMOs & Tourism Boards',
  'useCaseDMO.heroTitle': 'Your destination deserves more than a ',
  'useCaseDMO.heroTitleHighlight': 'brochure website.',
  'useCaseDMO.heroDesc':
    'Trippp gives tourism boards a modular digital platform: an interactive map, a cinematic discovery experience, and a full content management system — all white-labeled, multilingual, and deployable in weeks.',
  'useCaseDMO.bookDemo': 'Book a Demo',
  'useCaseDMO.challengeTitle': 'What DMOs face today.',
  'useCaseDMO.pain0': 'Static websites that no traveler bookmarks.',
  'useCaseDMO.pain1':
    "Content scattered across PDFs, social media, and third-party platforms you don't control.",
  'useCaseDMO.pain2':
    'Zero digital infrastructure to compete with destinations that have 10x your budget.',
  'useCaseDMO.solutionTitle':
    'Map + Spark: the digital backbone of your destination.',
  'useCaseDMO.mapDesc':
    'Give visitors a navigable, filterable, multilingual map of everything your region offers. Manage all content through a tourism-specific CMS — places, itineraries, hiking trails, deals, articles.',
  'useCaseDMO.sparkDesc':
    'Create an emotional first impression. A cinematic, swipeable experience that makes travelers feel your destination before they plan. Embeddable, brandable, shareable.',
  'useCaseDMO.sharedNote':
    '"Both products share the same CMS and API. One content effort powers two experiences."',
  'useCaseDMO.deploymentsTitle': 'Real deployments.',
  'useCaseDMO.deployment0Title': 'Visit Beni Mellal-Khénifra',
  'useCaseDMO.deployment0Desc':
    "A regional tourism board in Morocco deployed Trippp Map and Spark to digitise a previously underpromoted destination — giving visitors an interactive, multilingual window into the region's mountains, valleys, and culture.",
  'useCaseDMO.deployment1Title': 'Visit Draa-Tafilalet',
  'useCaseDMO.deployment1Desc':
    "Morocco's gateway to the Sahara now has an interactive destination map covering its vast territory — cities, oases, kasbahs, and trekking routes, all fully multilingual.",
  'useCaseDMO.seeItLive': 'See it live',
  'useCaseDMO.whatYouGetTitle': 'What you get.',
  'useCaseDMO.check0': 'White-label platform under your destination brand',
  'useCaseDMO.check1': 'Dedicated CMS built for tourism content',
  'useCaseDMO.check2': 'Multilingual — any language, powered by AI',
  'useCaseDMO.check3': 'REST API with public documentation',
  'useCaseDMO.check4': 'PWA — installable, works offline, no app store',
  'useCaseDMO.check5': 'Ongoing hosting and platform updates included',
  'useCaseDMO.ctaTitle': 'Put your region on the digital map. ',
  'useCaseDMO.ctaHighlight': 'Literally.',
  'useCaseDMO.ctaCta': 'Book a 30-minute walkthrough',

  // Use Case DMC Page
  'useCaseDMC.badge': 'DMCs & Travel Agencies',
  'useCaseDMC.heroTitle': 'Run operations that impress your clients and ',
  'useCaseDMC.heroTitleHighlight': 'close your commissions.',
  'useCaseDMC.heroDesc':
    'Trippp Ops gives your agency a white-label traveler app and operations dashboard for every trip you run. Your travelers get a seamless in-trip experience. Your team gets full visibility on bookings, extras, and commissions.',
  'useCaseDMC.bookDemo': 'Book a Demo',
  'useCaseDMC.challengeTitle': 'What DMCs face today.',
  'useCaseDMC.pain0':
    'Managing trip logistics across WhatsApp groups, emails, and shared documents.',
  'useCaseDMC.pain1':
    'No visibility on what extras travelers are buying — and no way to capture commissions on them.',
  'useCaseDMC.pain2':
    'Losing international mandates to competitors who look more digitally professional.',
  'useCaseDMC.solutionTitle': 'Trippp Ops: one platform for every operation.',
  'useCaseDMC.travelerAppTitle': 'Traveler App Features',
  'useCaseDMC.travelerFeature0': 'Program & Itinerary',
  'useCaseDMC.travelerFeature1': 'Extras Marketplace',
  'useCaseDMC.travelerFeature2': 'Documents Library',
  'useCaseDMC.travelerFeature3': 'Emergency Contacts',
  'useCaseDMC.adminDashboardTitle': 'Admin Dashboard Features',
  'useCaseDMC.adminFeature0': 'Trip Creation & Management',
  'useCaseDMC.adminFeature1': 'White-Label per Operation',
  'useCaseDMC.adminFeature2': 'Booking & Commission Tracking',
  'useCaseDMC.adminFeature3': 'Broadcast Messaging',
  'useCaseDMC.whiteLabelNote':
    '"Every operation can be white-labeled to a different brand — yours, your partner\'s, or your client\'s agency. Same platform, different face."',
  'useCaseDMC.edgeTitle': 'Win mandates. Keep commissions. Look world-class.',
  'useCaseDMC.scenario0':
    "A Brazilian agency mandates Trippp Ops to their Moroccan DMC provider. Every operation in Morocco runs through the platform — white-labeled under the Brazilian agency's brand. The agency gets full visibility on extras sold and commissions earned, even from 10,000 km away.",
  'useCaseDMC.scenario1':
    'A Moroccan DMC pitches an international agency for a 200-person incentive trip. Their differentiator? A branded traveler app with a full service marketplace, document access, and real-time updates. The agency picks them over three competitors who offered spreadsheets and PDFs.',
  'useCaseDMC.deploymentTitle': 'Real deployment.',
  'useCaseDMC.deployment0Title': 'Lumi Morocco',
  'useCaseDMC.deployment0Desc':
    "A Moroccan DMC deployed Trippp Ops to give their international clients' travelers a fully branded in-trip experience — program, extras, documents, and real-time communication, all under the Lumi name.",
  'useCaseDMC.learnMore': 'Learn more',
  'useCaseDMC.pricingTitle': 'Simple pricing. Scales with your operations.',
  'useCaseDMC.platformLicense': 'Platform license',
  'useCaseDMC.perOperation': 'Per operation',
  'useCaseDMC.seeFullPricing': 'See full pricing',
  'useCaseDMC.ctaTitle':
    'Your next client is choosing between you and a spreadsheet-based competitor. ',
  'useCaseDMC.ctaHighlight': 'Make it obvious.',
  'useCaseDMC.ctaCta': 'Book a 30-minute walkthrough',

  // Use Case Hotels Page
  'useCaseHotels.badge': 'Hotels & Resorts',
  'useCaseHotels.heroTitle': 'Your guests want to explore. ',
  'useCaseHotels.heroTitleHighlight': 'Give them a reason to start with you.',
  'useCaseHotels.heroDesc':
    'Trippp gives hotels and resorts two tools to enrich the guest experience: an interactive map of the surrounding destination and a cinematic discovery experience — both embeddable on your website, both branded as yours.',
  'useCaseHotels.bookDemo': 'Book a Demo',
  'useCaseHotels.challengeTitle': 'What Hotels face today.',
  'useCaseHotels.pain0':
    "A beautiful hotel website that stops at the lobby. Nothing about what's around you.",
  'useCaseHotels.pain1':
    'Guests discover the destination on TripAdvisor or Google — not through your brand.',
  'useCaseHotels.pain2':
    'No way to differentiate beyond room photos and amenity lists.',
  'useCaseHotels.solutionTitle': 'The Trippp solution.',
  'useCaseHotels.mapTitle': 'Trippp Map — Property tier',
  'useCaseHotels.mapDesc':
    'An interactive map of your surroundings. Restaurants, activities, cultural sites, beaches, trails — curated by you, presented under your brand. Guests explore the destination through your lens.',
  'useCaseHotels.sparkTitle': 'Trippp Spark — Property tier',
  'useCaseHotels.sparkDesc':
    'A cinematic page on your website that lets future guests feel the destination emotionally. Not a photo gallery — a full-screen, swipeable, mood-driven discovery experience.',
  'useCaseHotels.fitsTitle': 'Embedded seamlessly. Branded completely.',
  'useCaseHotels.fit0':
    "Spark becomes a page on your website — 'Explore the Destination' — that no competitor hotel has.",
  'useCaseHotels.fit1':
    'Map lives as an interactive guide guests can access before and during their stay.',
  'useCaseHotels.fit2':
    "Both carry your hotel's logo, colours, and domain. Visitors never leave your brand.",
  'useCaseHotels.ctaTitle': 'Stop selling rooms. ',
  'useCaseHotels.ctaHighlight': 'Start selling the experience around them.',
  'useCaseHotels.ctaCta': 'Book a 30-minute walkthrough',

  // Use Case Real Estate Page
  'useCaseRealEstate.badge': 'Real Estate & Lifestyle',
  'useCaseRealEstate.heroTitle': "You're not selling square metres. ",
  'useCaseRealEstate.heroTitleHighlight': "You're selling a life.",
  'useCaseRealEstate.heroDesc':
    'Trippp gives real estate and lifestyle developers tools to showcase the destination around the property — trails, restaurants, culture, experiences — turning location from a line item into the main attraction.',
  'useCaseRealEstate.bookDemo': 'Book a Demo',
  'useCaseRealEstate.challengeTitle': 'What Developers face today.',
  'useCaseRealEstate.pain0':
    "Buyers see floor plans and renders. They don't feel the lifestyle.",
  'useCaseRealEstate.pain1':
    'Location is mentioned as a bullet point, never as an experience.',
  'useCaseRealEstate.pain2':
    'Competing developments in the same area all look the same on paper.',
  'useCaseRealEstate.solutionTitle': 'The Trippp solution.',
  'useCaseRealEstate.mapDesc':
    'An interactive map of the surrounding area — dining, outdoor activities, cultural sites, schools, transport. Prospective buyers explore the neighbourhood through a curated, branded lens.',
  'useCaseRealEstate.sparkDesc':
    'A cinematic experience that makes buyers feel the lifestyle before they visit the showroom. The mountain trails at sunrise. The coastal restaurants at sunset. The cultural scene on weekends.',
  'useCaseRealEstate.impactTitle': 'Make the environment part of the pitch.',
  'useCaseRealEstate.impact0':
    'When two developments offer similar specs at similar prices, the one that sells the lifestyle wins. Trippp makes the lifestyle tangible.',
  'useCaseRealEstate.impact1':
    'Embed Map and Spark into your sales website, your brochures, your showroom screens. Every touchpoint becomes an immersive argument.',
  'useCaseRealEstate.ctaTitle': 'Sell the view. Sell the trail. ',
  'useCaseRealEstate.ctaHighlight': 'Sell the Saturday morning.',
  'useCaseRealEstate.ctaCta': 'Book a 30-minute walkthrough',
}
